export type MultiAction = {
  id: string;
  label: string;
  icon?: string;
  svgIcon?: string;
  tooltip?: string;
  color?: 'primary' | 'accent' | 'warn';
  iconColor?: 'primary' | 'accent' | 'warn';
  disabled?: boolean;
  hidden?: boolean;
  className?: string;
};

const adminMultiActions = [
  {
    id: 'multiManageEditPermission',
    label: 'Manage Permission',
    icon: 'add',
    iconColor: 'accent',
  },
  {
    id: 'multiManageEditNotification',
    label: 'Manage Notification',
    icon: 'add_alert',
    iconColor: 'accent',
  },
  {
    id: 'multiManageEditDataForwarding',
    label: 'Manage Data Forwarding',
    icon: 'email',
    iconColor: 'accent',
  },
  {
    id: 'multiAddMovebankForwarding',
    label: 'Add Movebank Forwarding',
    icon: 'forward',
    iconColor: 'accent',
  },
  {
    id: 'multiAddGenerateCollarKey',
    label: 'Generate Collar Keys',
    icon: 'key',
    iconColor: 'accent',
  },
  {
    id: 'multiAddGenerateDropOffKeys',
    label: 'Generate Drop Off Keys',
    icon: 'key',
    iconColor: 'accent',
  },
  {
    id: 'showPositions',
    label: 'Show data',
    icon: 'calendar_view_week',
    iconColor: 'accent',
    tooltip: 'show data',
  },
  {
    id: 'showTrapEvents',
    label: 'Show trap events',
    icon: 'calendar_view_week',
    iconColor: 'accent',
    tooltip: 'show trap events',
  },
  {
    id: 'showPositionOnMap',
    label: 'Show on map',
    icon: 'location_on',
    iconColor: 'accent',
    tooltip: 'show on map',
  },
  {
    id: 'copyDeviceIdsToClipboard',
    label: 'Copy Device IDs to Clipboard',
    icon: 'content_copy',
    iconColor: 'accent',
  },
  {
    id: 'copyDeviceComIdsToClipboard',
    label: 'Copy Device COM IDs to Clipboard',
    icon: 'content_copy',
    iconColor: 'accent',
  },
  {
    id: 'multiEditPaymentAccount',
    label: 'Manage Airtime Account',
    icon: 'credit_card',
    iconColor: 'accent',
  },
  {
    id: 'multiEditNetworkStatus',
    label: 'Manage Network Status',
    icon: 'toggle_on',
    iconColor: 'accent',
  },
  {
    id: 'multiEditComProvider',
    label: 'Manage Com Provider',
    icon: 'satellite_alt',
    iconColor: 'accent',
  },
  {
    id: 'multiEditDataPlan',
    label: 'Manage Data Plan',
    icon: 'monitoring',
    iconColor: 'accent',
  },
  {
    id: 'compareTelemetry',
    label: 'Compare Telemetry',
    icon: 'compare',
    iconColor: 'accent',
    tooltip: 'Compare telemetry data across selected collars',
  },
] as const satisfies readonly MultiAction[];

export type AdminMultiActionId = (typeof adminMultiActions)[number]['id'];

export function getAdminMultiAction(id: AdminMultiActionId): MultiAction | undefined {
  return adminMultiActions.find((a) => a.id === id);
}
